import toast from "react-hot-toast";

export const success = (message = `Operación realizada`) =>
  toast.success(message, { position: "top-center", duration: 5000 });

export const toastError = (
  message = `Se ha producido un error, intentalo más tarde`
) => toast.error(message, { position: "top-center", duration: 5000 });
